import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-b from-cream to-white py-10 md:py-16 px-6" data-id="element-35">
      <div className="max-w-4xl mx-auto text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-37">
          <div className="flex justify-center mb-4" data-id="element-38">
            <HeartIcon className="w-12 h-12 text-rose" strokeWidth={1.5} data-id="element-39" />
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brown mb-4 leading-tight" data-id="element-40">
            El Código del Vientre: Sana tu árbol familiar y abre paso al milagro
            de la vida
          </h1>

          <h2 className="font-sans text-xl md:text-2xl text-rose font-medium mb-8 leading-relaxed" data-id="element-41">
            El protocolo sistémico de 5 pasos para mujeres que han intentado
            todo y sienten que un bloqueo invisible detiene su maternidad.
          </h2>

          <div className="mb-8" data-id="element-42">
            <img src="https://cdn.magicpatterns.com/uploads/jaNPaQf9phkMAj9ZuKSXmK/Codigo_del_Vientre.png" alt="El Código del Vientre - Disponible en todos tus dispositivos" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg" data-id="element-43" />
          </div>

          <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-6 md:p-10 mb-8 shadow-sm border border-rose/10" data-id="element-44">
            <p className="font-sans text-lg md:text-xl text-brown/90 leading-relaxed italic" data-id="element-45">
              Son las 11 de la noche. El baño está en silencio y vuelves a mirar
              ese espacio en blanco en el test de embarazo. Ese vacío frío en el
              pecho ya te es familiar. Has tomado las vitaminas, has calculado
              los días, has gastado fortunas en especialistas... y sin embargo,
              el hijo que tanto sueñas parece no encontrar el camino hacia ti.
            </p>
            <p className="font-sans text-lg md:text-xl text-brown/90 leading-relaxed mt-4 font-medium" data-id="element-46">
              No es que tu cuerpo esté fallando. Es que, a veces, la fertilidad
              no es un problema de hormonas, sino de un "nudo" en la historia de
              tu familia que aún no ha sido desatado.
            </p>
          </div>

          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-47">
            <span className="font-serif text-3xl text-brown/40 line-through" data-id="element-48">
              $27
            </span>
            <span className="font-serif text-5xl font-bold text-rose" data-id="element-49">
              $6.36
            </span>
            <span className="font-sans text-sm text-brown/60" data-id="element-50">USD</span>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => {
          trackAddToCart();
          window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
        }} className="bg-rose text-white font-sans font-semibold text-lg px-12 py-5 rounded-full shadow-lg hover:bg-rose/90 transition-colors cursor-pointer" data-id="element-51">
            Quiero Sanar Mi Linaje y Recibir a Mi Hijo
          </motion.button>
          <p className="font-sans text-sm text-brown/60 mt-3" data-id="element-52">
            Acceso inmediato y discreto para comenzar esta misma noche.
          </p>
        </motion.div>
      </div>
    </section>;
}